import * as glassEasel from 'glass-easel';
export class ResizeObserver {
    /** @internal */
    constructor(comp, observeAll) {
        this._$mode = 1 /* glassEasel.backend.ResizeObserverMode.ContentBox */;
        this._$observers = [];
        this._$comp = comp;
        this._$observeAll = observeAll;
    }
    contentBox() {
        this._$mode = 1 /* glassEasel.backend.ResizeObserverMode.ContentBox */;
        return this;
    }
    borderBox() {
        this._$mode = 2 /* glassEasel.backend.ResizeObserverMode.BorderBox */;
        return this;
    }
    observe(targetSelector, listener) {
        const shadowRoot = this._$comp._$.getShadowRoot();
        let targets;
        if (!shadowRoot) {
            targets = [];
        }
        else if (this._$observeAll) {
            targets = shadowRoot.querySelectorAll(targetSelector);
        }
        else {
            const elem = shadowRoot.querySelector(targetSelector);
            if (elem === null) {
                targets = [];
            }
            else {
                targets = [elem];
            }
        }
        targets.forEach((target) => {
            const observer = target.createResizeObserver(this._$mode, listener);
            if (observer === null) {
                // TODO warn no observer attached
            }
            else {
                this._$observers.push(observer);
            }
        });
    }
    disconnect() {
        const observers = this._$observers;
        this._$observers = [];
        observers.forEach((observer) => observer.disconnect());
    }
}
//# sourceMappingURL=resize.js.map